// Small pure helpers for BrainBrowser point-object names and file inputs.
// Extracted verbatim from NeuroViewer.jsx.

export const isPatientOrClinicalPointName = (name) => (
    Boolean(name) &&
    name.includes('-points') &&
    (name.includes('patient-') || name.includes('clinical-'))
);


export const getSelectedFileName = (fileTargetOrFile) => {
    if (!fileTargetOrFile) return null;
    if (fileTargetOrFile.name) return fileTargetOrFile.name;
    return fileTargetOrFile.files?.[0]?.name || null;
};
